import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {FieldDataConfig} from "../../../../model/fields.model";

@Component({
  selector: "admin-channels-view-fields",
  templateUrl: "./fields.component.html",
  styleUrls: ["./fields.component.css"]
})
export class AdminChannelViewFieldsFieldsComponent implements OnChanges {

  @Input() fields?: FieldDataConfig[];

  technicalFields: FieldDataConfig[]
  physicalFields: FieldDataConfig[]

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["fields"]) {
      this.technicalFields = this.fields?.filter(f => f.hash)!;
      this.physicalFields = this.fields?.filter(f => !f.hash)!;
    }
    }

  show(data: FieldDataConfig[]) {
    if (data) {
      return data.filter(f => !f.hash).length > 0;
    } else {
      return false;
    }
  }
}
